export const IMAGES = {
  bookCover: "/images/book-cover.jpg",
  signing: "/images/signing.jpg",
  stage: "/images/stage.jpg",
  jet: "/images/jet.jpg",
  handshake: "/images/handshake.jpg",
  elon: "/images/elon.jpg",
  trump: "/images/trump.jpg",
  cuban: "/images/cuban.jpg",
  patrickSnow: "/images/patrick-snow.jpg",
};

export const BOOK = {
  title: "Pursuance of Passion",
  subtitle: "The Success Roadmap for the Entrepreneur",
  author: "Nicholas Fordham",
  price: 19.95,
};

export const BONUSES = [
  {
    slug: "business-plan-ai",
    title: "The AI Business Plan Blueprint",
    desc: "Accelerated business planning and venture-capital targeting with generative AI — from competitor analysis to investor-ready 12-month pro formas, with turnkey prompt frameworks and a market-sizing matrix.",
    value: 97,
    accent: "#0f766e",
    highlights: [
      "AI Capital Architecture workflow diagram",
      "Venture evaluation & market-sizing matrix (SOM / SAM)",
      "12-month pro forma prompt frameworks",
      "Competitive analysis & pitch-audit scripts",
    ],
  },
  {
    slug: "grant-writing-ai",
    title: "The AI Grant Advantage",
    desc: "Research, write, and win funding with AI. Find hyper-targeted grant matches, build flawless logic models, and stress-test drafts against a built-in \"Mock Review Panel\" before you submit — plus copy-and-paste system prompts.",
    value: 97,
    accent: "#3b5b80",
    highlights: [
      "AI grant research & competitive alignment scoring",
      "Non-profit / entrepreneurial logic-model generation",
      "Modular proposal drafting protocol",
      "\"Mock Review Panel\" compliance stress-test",
    ],
  },
  {
    slug: "securing-funding-ai",
    title: "The AI Capital Catalyst",
    desc: "The small-business masterclass for unlocking grants, loans, and alternative financing with AI. Optimize your financials, build a lender-ready dossier, and deploy ready-to-use pre-underwriting and bank-loan narrative prompts.",
    value: 97,
    accent: "#4338ca",
    highlights: [
      "Smart Funding Acquisition Funnel diagram",
      "DSCR & underwriting data-modeling blocks",
      "Pre-underwriting audit scripts",
      "Bank-loan narrative templates",
    ],
  },
];

export const FEATURED = [
  { src: IMAGES.trump + "?v=2", name: "President Trump", ctx: "Private Roundtable" },
  { src: IMAGES.elon + "?v=2", name: "Elon Musk", ctx: "SpaceX, Cape Canaveral" },
  { src: IMAGES.cuban, name: "Mark Cuban", ctx: "Dallas Mavericks" },
];

export const TESTIMONIALS = [
  {
    quote: "This is the roadmap I wish I had at 25. Nicholas turns hard-won lessons into a system anyone can follow.",
    name: "Sarah Mitchell",
    role: "Founder, Lumen Studios",
  },
  {
    quote: "The AI bonus guides alone are worth ten times the price. I drafted my funding pitch in a single afternoon.",
    name: "David Okoye",
    role: "CEO, NorthBridge Logistics",
  },
  {
    quote: "Equal parts inspiring and practical. Pursuance of Passion lit a fire under our whole leadership team.",
    name: "Priya Raman",
    role: "Co-founder, Verdant Labs",
  },
];
